<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pb-2 mt-1" >
                <v-col sm="8" md="4" class="py-0">
                    <v-text-field
                        v-model="props.search"
                        append-icon="search"
                        :label="$t('stations.search')"
                        single-line
                        hide-details
                        class="mb-4 py-0 px-2 mt-0 tools-view-height"
                        style="background-color: var(--v-white_highlight-base); border: 1px solid black; border-radius:5px"
                    ></v-text-field>
                </v-col>
                <v-spacer></v-spacer> 
                <v-col cols="4" align="end" class="py-0">
                    <v-row class="mx-0 my-0 px-0 py-0" justify="end">
                        <v-btn class="right white_highlight--text tools-view-height" color="secondary" :to="'/stations/create'" v-permission="'station.create'">
                            {{ $t('stations.new') }}
                        </v-btn>
                    </v-row>
                </v-col>
            </v-row>
            <v-card class="px-0 size_buttons">
                <v-card-text class="py-3">
                    <v-row>
                        <v-col class="py-0">
                            <datatable :props="{headers:headers, items: props.items, search:props.search}" @methodHandler="methodHandler"></datatable>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-dialog v-model="modalDetail" persistent max-width="90%">
                <v-card >
                    <v-card-title class="justify-center">
                        <v-row align="center" justify="center">
                            <h4 class="text-uppercase blue_accent--text py-2">
                                {{ $t('stations.header') }} {{ this.station.id }}
                            </h4>
                        </v-row>
                    </v-card-title>
                    
                    <div class="marker1-1" style="font-weight:bold"><label class="mx-1">{{ $t('stations.details') }}</label></div>
                    <div class="detail_content1"><label style="font-weight:bold">{{ $t("stations.name") }}</label> <label>{{ this.station.name }}</label></div>
                    <div class="detail_content1" v-if="station.user != null"><label style="font-weight:bold">{{ $t("stations.user") }}</label> <label>{{ this.station.user.name + " " + this.station.user.paternal_surname }}</label></div>
                    <div class="detail_content1" v-if="station.user == null"><label style="font-weight:bold">{{ $t("stations.user") }}</label> <label> --- </label></div>
                                         
                    <div class="marker1-1 mt-2 detail_content1" style="font-weight:bold;"><label class="mx-1">{{ $t('stations._slots') }}</label> <v-spacer> </v-spacer> <label class="mx-1">{{ $t('stations.position') }}</label></div>
                    <span>
                        <div v-for="(slot, i) of station.slots" :key="i" class="detail_content1"><label style="font-weight:bold">{{ slot.name }}</label> <label>{{ slot.position }}</label></div>
                    </span>

                    <v-card-text class="mt-5">
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn color="secondary" class="white_highlight--text" @click="modalDetail = false">
                                {{ $t('stations.close') }}
                            </v-btn>
                        </div>
                    </v-card-text> 
                    <div class="marker1"></div>
                </v-card>
            </v-dialog>
            </v-container>     
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>
import { stationIndexUseCase } from "../application/use_cases/station_index_use_case";
import { HttpStationRepository } from "../infrastructure/station_repository";
import { stationShowUseCase } from "../application/use_cases/station_show_use_case";

export default {
    computed: {
        headers(){
            return [
                { text: this.$t('stations.id'), align: "center", value: 'id', class: 'text-uppercase' }, 
                { text: this.$t('stations.name'), align: "center", value: 'name', class: 'text-uppercase' },
                { text: this.$t('stations.user'), align: "center", value: 'user.name', class: 'text-uppercase' },
                { text: this.$t('stations.slots'), align: "center", value: 'slots_count', class: 'text-uppercase' },
                { text: this.$t('stations.actions'), align: "center", value: 'actions', class: 'text-uppercase' }
            ];
        } 
    },
    data(){
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            modalDetail: false,
            idStation: '',
            station: {
                "id": "",
                "name": "",
                "user": {
                    "id": "",
                    "email": "",
                    "warehouse_id": "",
                    "name": "",
                    "paternal_surname": ""
                },
                "warehouse": {
                    "id": "",
                    "name": ""
                },
                "slots": []
            },
            props: {
                search: '',
                items: [],
            }
        }
    },
    mounted(){
        this.index();
        this.$store.state.module = "headers.stations";
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        async index(){
            this.props.items = [];
            const result = await stationIndexUseCase(HttpStationRepository);
            this.props.items = result;
        },
        async show(station){
            const result = await stationShowUseCase(station.id, HttpStationRepository);
            this.station = result;
            this.modalDetail = true;
        }
    }
}
</script>

<style>

</style>